import { render, staticRenderFns } from "./ChatX1.vue?vue&type=template&id=23fc6fc3&"
import script from "./ChatX1.vue?vue&type=script&lang=js&"
export * from "./ChatX1.vue?vue&type=script&lang=js&"
import style0 from "./ChatX1.vue?vue&type=style&index=0&id=23fc6fc3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports